import React, { useEffect, useRef, useState } from 'react'
import _ from 'lodash'
import { Column } from 'primereact/column'
import { InputText } from 'primereact/inputtext'
import { Filtro } from '../../utils/Filtro'
import { routes } from '../../constants'
import apiService from '../../services/api.service'
import storage from '../../services/stoage.service'
import LtsLookup from './lts-lookup'
import '../../index.scss'

function resolveUsuarioNomePessoa(usuario) {
  if (!usuario) {
    return ''
  }
  const pessoa = _.get(usuario, 'pessoa')
  if (typeof pessoa === 'string' && _.trim(pessoa)) {
    return pessoa
  }
  return _.get(usuario, 'pessoa.value', '') || _.get(usuario, 'pessoa.nome', '') || _.get(usuario, 'nome', '') || ''
}

function resolveUsuarioIdValue(usuario) {
  if (!usuario) {
    return null
  }

  const id = _.get(usuario, 'id', _.get(usuario, 'oid', null))
  const nomePessoa = resolveUsuarioNomePessoa(usuario)
  const value = nomePessoa || _.get(usuario, 'label', '') || _.get(usuario, 'value', '') || _.get(usuario, 'login', '')

  if (!id || !value) {
    return null
  }

  return { id, value }
}

function resolveUsuarioDisplayValue(usuario) {
  const idValue = resolveUsuarioIdValue(usuario)
  if (idValue) {
    return idValue.value
  }
  return _.get(usuario, 'login', '')
}

function resolveCurrentUserFallback() {
  const oid = storage.getOidUser()
  const value = storage.getNomePessoaUsuario()
  if (!oid || !value) {
    return null
  }
  return { id: oid, value }
}

export default function LtsLookupUsuario(props) {
  const [filters, setFilters] = useState([])
  const defaultAppliedRef = useRef(false)
  const { value: valueProp, onChange } = props

  const columns = [
    {
      field: 'oid',
      header: 'Código',
      columnKey: 'oid',
      sortable: false,
      filter: true,
      columnSortField: 'oid',
      visible: true,
    },
    {
      field: 'login',
      header: 'Login',
      columnKey: 'login',
      sortable: true,
      filter: true,
      columnSortField: 'login',
      visible: true,
    },
    {
      field: 'pessoa.nome',
      header: 'Nome',
      columnKey: 'pessoa',
      sortable: true,
      filter: true,
      columnSortField: 'pessoa.nome',
      /** Mesmo contrato da tela Configurações → Usuários (filtro por nome da pessoa). */
      apiFilterCampo: 'nome',
      apiFilterRelacionamento: ['pessoa'],
      apiFilterChaveComponente: 'pessoa',
      visible: true,
    },
  ]

  const inputValue = valueProp
  const hasExplicitValue =
    !_.isNil(inputValue) &&
    !(typeof inputValue === 'string' && !_.trim(inputValue)) &&
    !(typeof inputValue === 'object' && !_.get(inputValue, 'id', null) && !resolveUsuarioDisplayValue(inputValue))

  useEffect(() => {
    const currentUser = resolveCurrentUserFallback()
    if (!defaultAppliedRef.current && !hasExplicitValue && currentUser && onChange) {
      defaultAppliedRef.current = true
      onChange(currentUser)
    }
  }, [hasExplicitValue, onChange])

  const loadDataFn = (params) => {
    return apiService.post('/lottustech/usuarios/all', params)
  }

  const onKeyPress = () => {
    const currentUser = resolveCurrentUserFallback()
    const value = resolveUsuarioDisplayValue(valueProp) || _.get(currentUser, 'value', '')
    if (value) {
      const fNome = new Filtro('nome', value, 'CONTEM', ['pessoa'])
      fNome.chaveComponente = 'pessoa'
      const filtros = [new Filtro('login', value, 'CONTEM'), fNome]
      setFilters([
        {
          campo: 'filtro',
          valor: filtros,
          tipoFiltro: 'OU',
        },
      ])
    }
  }

  const onComplete = (event) => {
    const value = _.get(event, 'query', '')
    if (value) {
      const fNome = new Filtro('nome', value, 'CONTEM', ['pessoa'])
      fNome.chaveComponente = 'pessoa'
      const filtros = [new Filtro('login', value, 'CONTEM'), fNome]
      setFilters([
        {
          campo: 'filtro',
          valor: filtros,
          tipoFiltro: 'OU',
        },
      ])
    }
  }

  const pathOnEditFn = () => {
    const oid = _.get(props, 'oidRecord', null)
    if (oid) {
      return `${routes.PATH_USUARIO}/${oid}`
    }
    return `${routes.PATH_USUARIO}/novo`
  }

  const onInputFilter = (e) => {
    const value = e.value
    if (typeof value === 'string') {
      onChange({ id: null, value })
    } else {
      onChange(resolveUsuarioIdValue(value))
    }
  }

  const autoCompleteTemplate = (data) => {
    const login = _.get(data, 'login', '')
    const nome = resolveUsuarioNomePessoa(data)
    return `${login}${login && nome ? ' - ' : ''}${nome}`
  }

  const columnFilterElement = (column) => {
    return <InputText style={{ width: '100%' }} name={column.field} onChange={(e) => onChangeTableFilter(column, e)} />
  }

  const onChangeTableFilter = (column, e) => {
    const campoApi = _.get(column, 'apiFilterCampo', _.get(column, 'columnKey', column.field))
    const newFilters = filters.filter((f) => f.campo !== campoApi)

    const valor = _.get(e, 'target.value', null)
    if (valor) {
      const tipoFiltro = column.field === 'oid' ? 'IGUAL_A' : 'CONTEM'
      const filtro = { campo: campoApi, valor, tipoFiltro }
      const relacionamento = column.apiFilterRelacionamento
      if (relacionamento) {
        filtro.relacionamento = relacionamento
      } else if (campoApi.includes('.')) {
        filtro.relacionamento = [campoApi.substring(0, campoApi.indexOf('.'))]
      }
      if (column.apiFilterChaveComponente) {
        filtro.chaveComponente = column.apiFilterChaveComponente
      }
      newFilters.push(filtro)
    }

    setFilters(newFilters)
  }

  const onResolvingColumn = () => {
    return columns.map((col) => {
      const columnProps = _.omit(col, [
        'columnKey',
        'columnSortField',
        'visible',
        'apiFilterCampo',
        'apiFilterRelacionamento',
        'apiFilterChaveComponente',
      ])
      const semIconesFiltro = {
        showFilterMenu: false,
        showClearButton: false,
        showFilterMenuOptions: false,
        showFilterMatchModes: false,
      }

      if (col.field === 'oid') {
        return (
          <Column
            {...columnProps}
            {...semIconesFiltro}
            key={col.field}
            bodyClassName="column-codigo-body-width"
            filterHeaderClassName="column-codigo-filter-header-width"
            headerClassName="column-codigo-header-width"
            filterElement={columnFilterElement(col)}
          />
        )
      }

      if (col.field === 'login') {
        return (
          <Column
            {...columnProps}
            {...semIconesFiltro}
            key={col.field}
            bodyClassName="column-descricao-body-width"
            filterHeaderClassName="column-descricao-filter-header-width"
            headerClassName="column-descricao-header-width"
            filterElement={columnFilterElement(col)}
          />
        )
      }

      if (col.field === 'pessoa.nome') {
        return (
          <Column
            {...columnProps}
            {...semIconesFiltro}
            key={col.field}
            body={(rowData) => resolveUsuarioNomePessoa(rowData)}
            bodyClassName="column-descricao-body-width"
            filterHeaderClassName="column-descricao-filter-header-width"
            headerClassName="column-descricao-header-width"
            filterElement={columnFilterElement(col)}
          />
        )
      }

      return null
    })
  }

  const resolveFilters = (paramsFilters) => {
    const oidEmpresa = _.get(storage.getCompany(), 'oid', null)
    if (oidEmpresa) {
      paramsFilters.push({
        campo: 'empresa.oid',
        valor: oidEmpresa,
        tipoFiltro: 'IGUAL_A',
        relacionamento: ['empresa'],
      })
    }
    return paramsFilters
  }

  const resolveDisplayValue = () => {
    return resolveUsuarioDisplayValue(valueProp) || _.get(resolveCurrentUserFallback(), 'value', '')
  }

  return (
    <React.Fragment>
      <LtsLookup
        label={props.label}
        value={resolveDisplayValue()}
        name={props.name}
        field={props.field}
        history={props.history}
        extraProjectionFields={['pessoa', 'nome']}
        autoCompleteTemplate={autoCompleteTemplate}
        onKeyPress={onKeyPress}
        onComplete={onComplete}
        onInputFilter={onInputFilter}
        pathOnEditFn={pathOnEditFn}
        header={props.label}
        columns={columns}
        onResolvingColumn={onResolvingColumn}
        loadDataFn={loadDataFn}
        resolveFilters={resolveFilters}
        onChange={(value) => props.onChange(resolveUsuarioIdValue(value))}
        filters={filters}
        setFilters={setFilters}
        editDisabled={props.editDisabled}
        editHidden={props.editHidden}
        disabled={props.disabled}
      />
    </React.Fragment>
  )
}
